import { logger } from "appworks/utils/logger";

export function log(message: string): void {
    logger.info("%c [GAME] Wrapper ", "background: #ccc; color: #fff", message);
}
